import { Store } from "@tanstack/store";
import type { Parent, AuthenticationResponse } from "@/lib/client/types.gen";

export interface AuthState {
	user: AuthenticationResponse | null;
	parent: Parent | null;
	token: string | null;
	isAuthenticated: boolean;
	isAdmin: boolean;
}

const getInitialState = (): AuthState => {
	const token = localStorage.getItem("token");
	const userStr = localStorage.getItem("user");
	const parentStr = localStorage.getItem("parent");

	if (token && userStr) {
		const user = JSON.parse(userStr) as AuthenticationResponse;
		const parent = parentStr ? (JSON.parse(parentStr) as Parent) : null;

		return {
			user,
			parent,
			token,
			isAuthenticated: true,
			isAdmin: user.role === "ADMIN",
		};
	}

	return {
		user: null,
		parent: null,
		token: null,
		isAuthenticated: false,
		isAdmin: false,
	};
};

const initialState: AuthState = getInitialState();

export const authStore = new Store<AuthState>(initialState);

export const setAuth = (
	user: AuthenticationResponse,
	token: string,
	parent?: Parent,
) => {
	localStorage.setItem("token", token);
	localStorage.setItem("user", JSON.stringify(user));
	if (parent) {
		localStorage.setItem("parent", JSON.stringify(parent));
	}
	authStore.setState(() => ({
		user,
		parent: parent || null,
		token,
		isAuthenticated: true,
		isAdmin: user.role === "ADMIN",
	}));
};

export const clearAuth = () => {
	localStorage.removeItem("token");
	localStorage.removeItem("user");
	localStorage.removeItem("parent");
	authStore.setState(() => ({
		user: null,
		parent: null,
		token: null,
		isAuthenticated: false,
		isAdmin: false,
	}));
};
